import { STATUS_TYPE } from '../../../enum';
import { AddOnCategory } from '../../addonCategory/api/interface';

export interface GetAddOnProduct {
  id: string;
}

export interface FindAddOnProduct {
  addonCategoryId?: string;
  search?: string;
}

export interface CreatePatchAddOnProduct {
  id?: string;
  labelEn: string;
  labelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  addonCategoryId: string;
  position: string;
  // stock: string;
  price: string;
  discountedPrice: string;
  previewUrl: string;
  activeState: boolean;
}

export interface AddOnProduct {
  id: string;
  labelEn: string;
  labelAr: string;
  // stock: string;
  price: string;
  discountedPrice: string;
  previewUrl: string;
  descriptionEn: string;
  descriptionAr: string;
  addonCategoryId: string;
  addon_category: AddOnCategory;
  position: string;
  activeState: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: AddOnProduct[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
